import { FieldsByConditions } from "../../types/config/config";
import { Listing } from "../../types/listing/listing";


export const getMatchedConditions = (conditionsList: FieldsByConditions[], listing: Listing): FieldsByConditions | undefined => {
    for (const item of conditionsList) {
        const conditions = item.conditions;
        const keys = Object.keys(conditions);
        const isMatch = keys.every(key => {
            const conditionValue = conditions[key];
            const listingValue = listing[key];

            if (listingValue === undefined) {
                return false; // Skip if listing doesn't have the key
            }

            if (Array.isArray(conditionValue)) {
                if (Array.isArray(listingValue)) {
                    // Use Set for faster lookup
                    const conditionSet = new Set(conditionValue);
                    return listingValue.every(val => conditionSet.has(val));
                }
                return conditionValue.includes(listingValue);
            }

            return listingValue === conditionValue;
        });
        if (isMatch) {
            return item;
        }
    }
    return;
}